import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";
import { FC } from "react";

export const LocationIconSvg = () => (
  <svg
    width="20"
    height="26"
    viewBox="0 0 20 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_435_1367)">
      <path
        d="M20 9.75C20 14.1883 13.9062 22.0898 11.2344 25.35C10.5938 26.127 9.40625 26.127 8.76562 25.35C6.09375 22.0898 0 14.1883 0 9.75C0 4.36719 4.47917 0 10 0C15.5208 0 20 4.36719 20 9.75Z"
        fill="currentColor"
      />
      <g clipPath="url(#clip1_435_1367)">
        <path
          d="M9.45963 5.93336C9.51465 5.83894 9.59347 5.7606 9.68822 5.70615C9.78297 5.6517 9.89034 5.62305 9.99963 5.62305C10.1089 5.62305 10.2163 5.6517 10.311 5.70615C10.4058 5.7606 10.4846 5.83894 10.5396 5.93336L11.9371 8.33236L14.6511 8.92036C14.7579 8.94356 14.8567 8.99434 14.9377 9.06763C15.0187 9.14092 15.0791 9.23417 15.1129 9.33808C15.1466 9.44198 15.1525 9.55292 15.13 9.65982C15.1075 9.76673 15.0574 9.86587 14.9846 9.94736L13.1346 12.0179L13.4146 14.7804C13.4257 14.8891 13.408 14.9989 13.3633 15.0987C13.3187 15.1985 13.2486 15.2849 13.1602 15.3491C13.0717 15.4134 12.968 15.4533 12.8592 15.465C12.7505 15.4766 12.6407 15.4595 12.5406 15.4154L9.99963 14.2954L7.45863 15.4154C7.35859 15.4595 7.24872 15.4766 7.14 15.465C7.03129 15.4533 6.92752 15.4134 6.83906 15.3491C6.75061 15.2849 6.68056 15.1985 6.63591 15.0987C6.59126 14.9989 6.57358 14.8891 6.58463 14.7804L6.86463 12.0179L5.01463 9.94786C4.94174 9.86638 4.8915 9.7672 4.86893 9.66022C4.84636 9.55325 4.85225 9.44223 4.886 9.33824C4.91975 9.23425 4.98019 9.14094 5.06128 9.06761C5.14237 8.99429 5.24128 8.94351 5.34813 8.92036L8.06213 8.33236L9.45963 5.93336Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_435_1367">
        <rect width="20" height="26" fill="white" />
      </clipPath>
      <clipPath id="clip1_435_1367">
        <rect
          width="12"
          height="12"
          fill="white"
          transform="translate(4 4.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const LocationIcon: FC<Partial<CustomIconComponentProps>> = (props) => (
  <Icon component={LocationIconSvg} {...props} />
);

export default LocationIcon;

LocationIcon.displayName = "LocationIcon";
